var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { WEEBLY_HOST } from '@square/dashboard-items-data/utils/sites/weebly';

// eslint-disable-next-line no-restricted-imports

const ECOM_SO_FREE = 'ecom-so-free';
const ECOM_SO_PROFESSIONAL = 'ecom-so-professional';
const ECOM_SO_PLUS = 'ecom-so-plus';
const ECOM_SO_PREMIUM = 'ecom-so-premium';
const ECOM_SO_PLANS_BASE_SERVICE_ID_MAP = new Map();
ECOM_SO_PLANS_BASE_SERVICE_ID_MAP.set(ECOM_SO_FREE, '0');
ECOM_SO_PLANS_BASE_SERVICE_ID_MAP.set(ECOM_SO_PROFESSIONAL, '74');
ECOM_SO_PLANS_BASE_SERVICE_ID_MAP.set(ECOM_SO_PLUS, '75');
ECOM_SO_PLANS_BASE_SERVICE_ID_MAP.set(ECOM_SO_PREMIUM, '76');

/**
 * A service to handle requests via the Ecom API.
 */
let EcomService = (_dec = service('chamber/chamber-ajax'), _class = class EcomService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "chamberAjax", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _defineProperty(this, "BaseURL", `${WEEBLY_HOST}/checkout/api/v2`);
    _defineProperty(this, "WebsiteURLv2", `${WEEBLY_HOST}/app/website/square/api/v2`);
    _defineProperty(this, "WebsiteSquareURLv1", `${WEEBLY_HOST}/app/website/square/api/v1`);
  }
  extendDomain(request = {}) {
    const {
      userServiceId,
      serviceItemId,
      instrumentToken
    } = request;
    const url = `${this.BaseURL}/domains/${userServiceId}/extensions`;
    return this.chamberAjax.ajax(url, 'POST', {
      service_item_id: serviceItemId,
      instrument_token: instrumentToken
    });
  }
  extendGoogleApps(request = {}) {
    const {
      userServiceId,
      instrumentToken
    } = request;
    const url = `${this.BaseURL}/googleapps/${userServiceId}/extend`;
    return this.chamberAjax.ajax(url, 'POST', {
      instrument_token: instrumentToken
    });
  }
  async getCurrentDomains() {
    const url = `${this.WebsiteURLv2}/domains`;
    const results = await this.chamberAjax.ajax(url, 'GET');
    const allDomains = results.data;
    const assignedDomains = allDomains.filter(domain => domain.assigned);
    return assignedDomains;
  }
  setSubdomains(subdomains) {
    const url = `${this.WebsiteURLv2}/subdomains/multiple`;
    return this.chamberAjax.ajax(url, 'POST', {
      assignments: subdomains
    });
  }
  async isSubdomainAvailable(subdomain) {
    const url = `${this.WebsiteSquareURLv1}/subdomains/${subdomain}`;
    const results = await this.chamberAjax.ajax(url, 'GET');
    return results?.available;
  }
  async isUserEligibleForSub2() {
    const url = `${this.BaseURL}/sub2/eligibility`;
    try {
      const results = await this.chamberAjax.ajax(url, 'GET');
      return results?.isUserEligibleForSub2;
    } catch (e) {
      // ECOM returns 401 to mean "user has no ECOM account."
      // All net-new SO accounts are sub2-eligible
      if (e.status === 401) {
        return true;
      }
      throw e;
    }
  }
  async isNonAuthenticatedUserEligibleForSub2() {
    const {
      countryCode,
      currencyCode,
      email
    } = this.userInfo;
    const url = `${this.BaseURL}/gbb/eligibility`;
    const results = await this.chamberAjax.ajax(url, 'GET', {
      country: countryCode,
      currency: currencyCode,
      email
    });
    return results?.is_eligible;
  }
  async getSub2MigrationStatus() {
    const url = `${this.BaseURL}/sub2/migration-status`;
    try {
      const results = await this.chamberAjax.ajax(url, 'GET');
      return results;
    } catch (e) {
      if (e.status === 401) {
        return {};
      }
      throw e;
    }
  }
  async getSubdomainSuggestions(siteId) {
    const url = `${this.WebsiteURLv2}/sites/${siteId}/domain-recommendations`;
    const results = await this.chamberAjax.ajax(url, 'GET');
    const subdomainSuggestions = [];
    const subDomainUnique = [...new Set(results.data.map(x => x.domain.split('.')[0]))];
    const availableSubdomainsPromises = await Promise.allSettled(subDomainUnique.map(subdomain => {
      return this.isSubdomainAvailable(subdomain);
    }));
    for (const i in availableSubdomainsPromises) {
      const status = availableSubdomainsPromises[i].status;
      const isSubdomainAvailable = availableSubdomainsPromises[i].value;
      if (status === 'rejected') {
        continue;
      }
      if (subdomainSuggestions.length === 3) {
        break;
      }
      if (isSubdomainAvailable) {
        subdomainSuggestions.push({
          id: i,
          domain: subDomainUnique[i]
        });
      }
    }
    return subdomainSuggestions;
  }
  getBaseServiceId(planToken) {
    return ECOM_SO_PLANS_BASE_SERVICE_ID_MAP.get(planToken);
  }
  async getLostFeatures(currentPlan, selectedPlan, mcc) {
    const url = `${this.BaseURL}/downgrade/features-lost`;
    const query = new URLSearchParams(`from=${currentPlan}`);
    if (selectedPlan.length > 0) {
      query.append('to', selectedPlan);
    }
    if (mcc.length > 0) {
      query.append('mcc', mcc);
    }
    const response = await this.chamberAjax.ajax(url, 'GET', Object.fromEntries(query));
    return Object.values(response.lost_features).filter(lostFeature => lostFeature.highlight && lostFeature.display.name).map(({
      id,
      display: {
        name
      }
    }) => ({
      id,
      name
    }));
  }
  async getCurrentFeatures() {
    const url = `${this.BaseURL}/features`;
    const results = await this.chamberAjax.ajax(url, 'GET');
    return results;
  }
  createDowngradeSurvey(currentPlan, selectedPlan, selectedReason, additionalDetails) {
    const url = `${this.BaseURL}/downgrade/survey`;
    return this.chamberAjax.ajax(url, 'POST', {
      from_plan: currentPlan,
      to_plan: selectedPlan,
      answer: selectedReason,
      additional_information: additionalDetails
    });
  }
  cancelService(userServiceId) {
    const url = `${this.BaseURL}/services/${userServiceId}/cancel`;
    return this.chamberAjax.ajax(url, 'POST');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "chamberAjax", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { EcomService as default };